module.exports = __webpack_public_path__ + "media/images/rmj_supply_logo-99351a878f2af6fce02aa0f9d9069918.png";